import React, {useState, useEffect} from 'react';
import { Carousel,  Button } from 'react-bootstrap';
import "./Style.css";
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import { usePopup } from './PopupContext'; 

// import img0 from '../../assets/banner-new.jpg';
import img000 from '../../assets/EYE CARE institute New Banner2.png';
import img00 from '../../assets/updated banner.jpg';
import img1 from '../../assets/carouselimg1.png';
import img2 from '../../assets/carouselimg2.png';
import img3 from '../../assets/carouselimg3.png';
import img4 from '../../assets/carouselimg4.png';
import img5 from '../../assets/carouselimg5.png';
import img6 from '../../assets/carouselimg6.png';
import img7 from '../../assets/carouselimg7.png';
import whoweare_img from '../../assets/whoweare_img.jpg';


import img45 from '../../assets/himi.png';
import img56 from '../../assets/the next u.jpg';



import { motion } from 'framer-motion';
import { Modal } from 'react-bootstrap';


import { FaHistory, FaUserTie, FaUsers, FaGlobeAmericas } from 'react-icons/fa';



import { FaGraduationCap, FaUserMd, FaMicroscope, FaCertificate,  FaArrowRight, FaClock, FaBook } from 'react-icons/fa';






export const ECBody = () => {

  // Sample event data - replace with your actual data source
  const [events, setEvents] = useState([










{
  title: "Convocation & Award Ceremony 2026",
  date: "22nd of March 2026",
  time: "02:00 PM",
  location: "@ BMICH",
  description: ` `,

  image: "/graduation img news.jpg",

},











//     {
//       id: 2,
//       title: "--- DIYATHARIPPU --- Eye Care 2026",
//       date: "25-26 January, 2026",
//       time: "09:00 AM",
//       location: "Monarch Imperial Hotel, Colombo",
//      description: 
//       `
// 1st International Optometric Conference in Sri Lanka \n

// Theme: “Vision Beyond Borders – Advancing Global Eye Care” \n


// Join us at a historic milestone in Sri Lanka’s optometric journey.
// DIYATARIPPU- EYE CARE 2026 the 1st International Optometric Conference in Sri Lanka brings together global experts, practitioners, educators, and students to explore the latest developments in vision science, eye care technology, and interdisciplinary practice.
// This international gathering offers an exceptional platform for collaboration, learning, and leadership in eye health.
// Conference will cover free presentation, symposiums & hand on workshops I n the following areas:
// 	•	Clinical Optometry & Vision Therapy
// 	•	Advances in Optometric Research
// 	•	Pediatric & Geriatric Eye Care
// 	•	Public Health & Community Eye Services
// 	•	Low Vision & Rehabilitation
// 	•	Technology in Vision Science
// 	•	Interdisciplinary Eye Care Models
// 	•	Optometric Education & Professionalism
// `, 
//       image: "/bannerloc.jpg",
//       featured: false
//     },




    // {
    //   id: 3,
    //   title: "Research Symposium",
    //   date: "July 2, 2025",
    //   time: "10:00 AM - 3:00 PM",
    //   location: "Conference Hall",
    //   description: "Showcase of student research projects with guest judges from the industry.",
    //   image: "https://via.placeholder.com/400x200?text=Research+Symposium",
    //   featured: true
    // },
    // {
    //   id: 4,
    //   title: "Alumni Networking",
    //   date: "July 5, 2025",
    //   time: "6:00 PM - 8:00 PM",
    //   location: "Campus Courtyard",
    //   description: "Evening networking event with alumni from various optometry practices.",
    //   image: "https://via.placeholder.com/400x200?text=Alumni+Networking",
    //   featured: false
    // }
  ]);

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Animation variants
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    },
    hover: {
      y: -5,
      boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
    }
  };









 const navigate = useNavigate();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [popup, setPopup] = useState({ show: false, message: '', key: '' });

  const event = {
    '2026-03-22': {
   title: 'Convocation & Award Ceremony 2026 | @ BMICH',
      path: '/',
    },
  };

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  const generateCalendar = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startDay = firstDay.getDay();

    const weeks = [];
    let week = [];

    for (let i = 0; i < startDay; i++) week.push(null);
    for (let day = 1; day <= daysInMonth; day++) {
      week.push(day);
      if (week.length === 7) {
        weeks.push(week);
        week = [];
      }
    }
    if (week.length > 0) {
      while (week.length < 7) week.push(null);
      weeks.push(week);
    }

    return weeks;
  };

  const weeks = generateCalendar(currentDate);

  const handleDayClick = (day, e) => {
    if (!day) return;
    e.stopPropagation();

    const dateStr = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    const eventData = event[dateStr];

    setPopup({
      show: true,
      message: eventData ? eventData.title : 'No event on this date',
      key: dateStr
    });
  };

  const closePopup = () => {
    setPopup({ show: false, message: '', key: '' });
  };

  useEffect(() => {
    const handleOutsideClick = () => closePopup();
    window.addEventListener('click', handleOutsideClick);
    return () => window.removeEventListener('click', handleOutsideClick);
  }, []);














const [hoveredCard, setHoveredCard] = useState(null);

  const courses = [
{
  id: 1,
  title: "Ophthalmic Optician (NVQ Level 3)",
  description: "Focused training in ophthalmic dispensing, including spectacle and lens selection, measurements, adjustments, and patient guidance.",
  duration: "06 Months",
  level: "Certificate",
  icon: FaCertificate,
  image: "certificate in optician.jpg",
  link: "/ophthalmicoptician",
  color: "#44b7f9ff",
  features: [
    "Spectacle & Lens Dispensing",
    "Measurements and Adjustments",
    "Patient Care"
  ]
},


    {
      id: 2,
      title: "Certificate in Ophthalmic Assistant",
      description: "Gain comprehensive expertise in opticianry with extensive hands-on clinical experience and theoretical knowledge.",
      duration: "01 year",
      level: "Certificate",
      icon: FaCertificate,
      image: "ophthalmic assistant.png",
      link: "/certificateinoptician",
      color: "#0e11b6ff",
      features: ["Practical Training", "Industry Exposure", "Certification"]
    },
    {
      id: 3,
      title: "Diploma in Optometry (NVQ Level 5)",
      description: "Master optometry principles and vision science through advanced clinical practice and research methodologies.",
      duration: "02 Years",
      level: "Diploma",
      icon: FaGraduationCap,
      image: "diploma img1.jpg",
      link: "/diplomainoptometry",
      color: "#066b49ff",
      features: ["Clinical Practice", "Research Methods", "Advanced Optics"]
    },
    {
      id: 4,
      title: "Higher Diploma in Optometry (NVQ Level 6)",
      description: "Advanced professional training in optometric sciences with specialized clinical rotations and research projects.",
      duration: "2 Years & 06 Months",
      level: "Higher Diploma",
      icon: FaUserMd,
      image: "higher diploma.jpeg",
      link: "/higherdiplomainoptometry",
      color: "#fea100ff",
      features: ["Specialized Training", "Clinical Rotations", "Research Projects"]
    },
    {
      id: 5,
      title: "Fellowship Courses",
      description: "Specialized advanced courses focusing on cutting-edge optometric techniques and clinical applications.",
      duration: "06 Months",
      level: "Fellowship",
      icon: FaMicroscope,
      image: "fellowship img.jpg",
      link: "/fellowshipcourse",
      color: "#5610f9ff",
      features: ["Advanced Techniques", "Clinical Applications", "Specialization"]
    },
    {
      id: 6,
      title: "Fellowship Workshops",
      description: "Intensive skill development workshops focusing on advanced optometric management and clinical procedures.",
      duration: "1-5 Days",
      level: "Workshop",
      icon: FaUsers,
      image: "Workshopimg.jpg",
      link: "/onedayworkshop",
      color: "#f13535ff",
      features: ["Skill Enhancement", "Latest Technologies", "Hands-on Training"]
    },
            {
          id: 7,
          title: "NVQ Course | Level 3 & 5",
          description: "Comprehensive NVQ Level 3 Ophthalmic optician training designed to develop practical competencies, industry knowledge, and professional skills required for excellence in optician level practice.",
          duration: "",
          level: "NVQ Level 3 & 5",
          icon: FaCertificate,
          image: "NVQ-certificates.jpg",
          link: "/registration-course",
          color: "#d39b00ff",
          features: ["Skill Enhancement", "Clinical Applications", "Hands-on Training"]
        }
  ];

  const cardVariants2 = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    },
    hover: {
      y: -15,
      scale: 1.02,
      transition: { duration: 0.3 }
    }
  };











  return (


<div className="py-0 mt-0 link-color" style={{ 
  overflowX: 'hidden',
  width: '100%',
  maxWidth: '100%'
}}>
        {/* Auto Sliding Banner */}
        <Carousel className="mb-5">


            <Carousel.Item>
              <Link to="/registration-course">
                <img
                  className="d-block w-100"
                  src={img000}
                  alt="very first slide"
                  style={{ cursor: 'pointer' }}
                />
              </Link>
 
            </Carousel.Item>


            <Carousel.Item>
              <Link to="/registration-course">
                <img
                  className="d-block w-100"
                  src={img00}
                  alt="very first slide"
                  style={{ cursor: 'pointer' }}
                />
              </Link>
 
            </Carousel.Item>


          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={img1}
              alt="First slide"
            />
            {/* <Carousel.Caption>
              <h3>Diyatharippu</h3>
              <p>1st Internatinal Conference</p>
            </Carousel.Caption> */}
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src={img4}
              alt="Second slide"
            />
            {/* <Carousel.Caption>
              <h3>World-Class Optometry Education</h3>
              <p>Learn from the best in the field.</p>
            </Carousel.Caption> */}
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={img3}
              alt="Third slide"
            />
            {/* <Carousel.Caption>
              <h3>Innovative Eye Care Solutions</h3>
              <p>Shaping the future of vision care.</p>
            </Carousel.Caption> */}
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={img2}
              alt="Fourth slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={img7}
              alt="sixthth slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={img5}
              alt="Fifth slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={img6}
              alt="sixthth slide"
            />
          </Carousel.Item>
        </Carousel>


          
            <div className="container mb-5">
              <div className="row align-items-center">


                <div className="col-md-6 custom-para">
                  <h2>Who We Are</h2>
                <p>
                  Founded in 2007 as a School of Optometry, the Eye Care Institute (ECI) has grown into a leading non-state higher education institution dedicated to advancing eye care education in Sri Lanka.
                  </p>

                  <p>
                  In response to the evolving landscape of modern optometric practice, ECI has continually expanded its curriculum and clinical programmes not only within the institute itself, but across all levels of the eye care sector.
                  </p>

                  <p>
                  Today, we offer a range of recognised Optician and Optometry programmes designed to meet national and international demand. Approved by the Ministry of Education and accredited by the Tertiary & Vocational Education Commission (TVEC), ECI is proud to be the first private Optometry institute in Sri Lanka recognised by the Government.
                  </p>

                  <p>
                  We are also the only Optometry institute in the country affiliated with a university. Our international standing is further affirmed by our membership in the World Council of Optometry (WCO) and the Asia Pacific Council of Optometry (APCO), while our programmes are locally recognised by the Ceylon Council of Optometrists & Orthoptists (CCOO), Sri Lanka.
                  </p>

 


                </div>
                <div className="col-md-6">
                  <img
                    src={whoweare_img}
                    alt="Who We Are"
                    className="img-fluid rounded custom-img"
                  />
                </div>
                <div
                    className="know-more">
                    <a href="/whoweare" className="contact-button text-decoration-none">
                      More info <span>&#x2192;</span>
                    </a>
                  </div>
              </div>
            </div>



         {/* Unique Features Section */}
<div className="container mb-5 text-center custom-unique">
  <h4 className="section-title-legacy mb-5">A Legacy of Excellence</h4>
  <div className="row">
    <div className="col-md-3 feature-card">
      <div className="feature-item">
        <FaHistory className="feature-icon" />
        <h2 className="feature-title">18+</h2>
        <p className="feature-description">Years of Academic Excellence</p>
      </div>
    </div>
    <div className="col-md-3 feature-card">
      <div className="feature-item">
        <FaUserTie className="feature-icon" />
        <h2 className="feature-title">32+</h2>
        <p className="feature-description">Expert Faculty Members</p>
      </div>
    </div>
    <div className="col-md-3 feature-card">
      <div className="feature-item">
        <FaUsers className="feature-icon" />
        <h2 className="feature-title">350+</h2>
        <p className="feature-description">Successful Alumni</p>
      </div>
    </div>
    <div className="col-md-3 feature-card">
      <div className="feature-item">
        <FaGlobeAmericas className="feature-icon" />
        <h2 className="feature-title">7+</h2>
        <p className="feature-description">Countries of Alumni Network</p>
      </div>
    </div>
  </div>
</div>


            {/* What Do You Want to Study Section */}
      {/* <div className="container mb-5 study-section">
        <h2 className="text-center section-title">What Do You Want to Study?</h2>
            <div className="row">
              <div className="col-md-3 mb-4">
                <div className="card study-card">
                  <img src="certificate in optician.jpg" alt="Certificate in Optician" className="card-img-top" />
                  <div className="card-body">
                    <h5 className="card-title">Certificate in Optician</h5>
                    <p className="card-text">Gain expertise in opticianry with hands-on experience.</p>
                    <Button variant="primary" className="btn-learn-more" href="/certificateinoptician" >More Info</Button>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div className="card study-card">
                  <img src="diploma img1.jpg" alt="Diploma in Optometry" className="card-img-top" />
                  <div className="card-body">
                    <h5 className="card-title">Diploma in Optometry</h5>
                    <p className="card-text">Gain expertise in optometry and study vision science.</p>
                    <Button variant="primary" className="btn-learn-more" href="/diplomainoptometry">More Info</Button>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div className="card study-card">
                  <img src="higher diploma.jpeg" alt="Higher Diploma in Optometry" className="card-img-top" />
                  <div className="card-body">
                    <h5 className="card-title">Higher Diploma in Optometry</h5>
                    <p className="card-text">Gain expertise in optometry and study vision science.</p>
                    <Button variant="primary" className="btn-learn-more" href="/higherdiplomainoptometry">More Info</Button>
                  </div>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div className="card study-card">
                  <img src="shortcoursesimg.png" alt="Diploma in Optometry" className="card-img-top" />
                  <div className="card-body">
                  <h5 className="card-title">Fellowship Courses</h5>
                  <p className="card-text">Explore the science of eye health through the short course.</p>

                    <Button variant="primary" className="btn-learn-more" href="/fellowshipcourse" >More Info</Button>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mb-4">
                <div className="card study-card">
                  <img src="fellowship img.jpg" alt="Certificate in Optician" className="card-img-top" />
                  <div className="card-body">
                    <h5 className="card-title">Fellowship Workshops</h5>
                    <p className="card-text">To enhance the skill on optometric management.</p>
                    <Button variant="primary" className="btn-learn-more" href="/onedayworkshop">More Info</Button>
                  </div>
                </div>
              </div>
            </div>
      </div>

 */}
 <section className="courses-section">
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Faculty of Optometry</h2>
          <p className="section-subtitle">Choose from our comprehensive range of optometry programs designed for career success</p>
        </motion.div>

        <div className="courses-grid">
          {courses.map((course, index) => (
            <motion.div
              key={course.id}
              className="course-card"
              variants={cardVariants2}
              initial="hidden"
              whileInView="visible"
              whileHover="hover"
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              onMouseEnter={() => setHoveredCard(course.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="card-header">
                <div 
                  className="card-icon"
                  style={{ backgroundColor: `${course.color}15`, borderColor: course.color }}
                >
                  <course.icon style={{ color: course.color }} />
                </div>
                <div className="course-level" style={{ backgroundColor: course.color }}>
                  {course.level}
                </div>
              </div>

              <div className="card-image">
                <img src={course.image} alt={course.title} />
                <div className="image-overlay" style={{ backgroundColor: `${course.color}20` }}></div>
              </div>

              <div className="card-content">
                <h3 className="course-title">{course.title}</h3>
                <p className="course-description">{course.description}</p>
                
                <div className="course-duration">
                  <FaClock />
                  <span>{course.duration}</span>
                </div>

                <div className="course-features">
                  {course.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag" style={{ borderColor: course.color }}>
                      {feature}
                    </span>
                  ))}
                </div>
              </div>

              <div className="card-footer">
                <motion.a 
                  href={course.link}
                  className="learn-more-btn"
                  style={{ 
                    backgroundColor: hoveredCard === course.id ? course.color : 'transparent',
                    borderColor: course.color,
                    color: hoveredCard === course.id ? 'white' : course.color
                  }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Learn More
                  <FaArrowRight />
                </motion.a>
              </div>

              {/* Hover Effect Border */}
              <div 
                className="hover-border"
                style={{ 
                  background: `linear-gradient(135deg, ${course.color}, ${course.color}dd)`,
                  opacity: hoveredCard === course.id ? 1 : 0
                }}
              ></div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="section-footer text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <p className="info-text">Can't find what you're looking for?</p>
          <motion.a 
            href="/contactus"
            className="contact-link"
            whileHover={{ scale: 1.05 }}
          >
            Contact Our Academic Advisors <FaArrowRight />
          </motion.a>
        </motion.div>
      </div>
    </section>









  <div className="calendar-page">
      <div className="calendar-layout">
        <div className="calendar-side-image">
          <img src={img45} alt="event" className="side-img" />
        </div>

        <div className="calendar-container">
          <div className="calendar-header">
            <div className="month-navigation">
              <h4>{monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}</h4>
            </div>
          </div>

          <div className="days-container">
            {weeks.map((week, weekIndex) => (
              <div key={weekIndex} className="calendar-week">
                {weekIndex === 0 && (
                  <div className="day-names">
                    {daysOfWeek.map(day => (
                      <div key={day} className="day-name">{day}</div>
                    ))}
                  </div>
                )}

                <div className="days-row">
                {week.map((day, dayIndex) => {
                  if (day === null) return <div key={dayIndex} className="empty-day"></div>;

                  const dateStr = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
                  const hasEvent = !!event[dateStr];

                  return (
                    <div
                      key={day}
                      className={`day ${hasEvent ? 'has-event' : ''}`}
                      onClick={(e) => handleDayClick(day, e)}
                    >
                      <div className="day-number">{day}</div>

                      {/* Event tag (just half shown info) */}
                      {hasEvent && <div className="event-hint"><span></span></div>}

                      {/* Full inline popup on click */}
                      {popup.show && popup.key === dateStr && (
                        <div className="inline-popup">
                          {popup.message}
                        </div>
                      )}
                    </div>
                  );
                })}

                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="calendar-side-image">
          <img src={img56} alt="event" className="side-img" />
        </div>
      </div>
    </div>










    <section className="event-section py-5" id="events">
      <div className="container">
        <h2 className="text-center mb-5 section-title">
          {/* <span className="highlight">Events</span>  */}
        </h2>
        
        <div className="row">
          {events.map((event, index) => (
            <motion.div 
              key={event.id}
              className={`col-md-${event.featured ? '6' : '3'} mb-4`}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              whileHover="hover"
              custom={index}
            >
              <div 
                className={`card h-100 event-card ${event.featured ? 'featured' : ''}`}
                onClick={() => handleEventClick(event)}
              >
                <div className="card-img-container">
                  <img 
                    src={event.image} 
                    className="card-img-top" 
                    alt={event.title}
                  />
                  {event.featured && (
                    <div className="featured-badge">
                      Featured Event
                    </div>
                  )}
                </div>
                <div className="card-body">
                  <h5 className="card-title">{event.title}</h5>
                  <div className="event-meta">
                    <div className="meta-item">
                      <i className="far fa-calendar-alt"></i>
                      <span>{event.date}</span>
                    </div>
                    <div className="meta-item">
                      <i className="far fa-clock"></i>
                      <span>{event.time}</span>
                    </div>
                    <div className="meta-item">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{event.location}</span>
                    </div>
                  </div>
                  <p className="card-text">{event.description.substring(0, 100)}...</p>
                </div>
                <div className="card-footer bg-transparent">
                  <button className="btn btn-primary btn-sm">
                    View Details
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-4">
          <Button 
            variant="outline-primary" 
            href="/newsandevents" 
            className="view-all-btn"
          >
            View All Events <i className="fas fa-arrow-right ml-2"></i>
          </Button>
        </div>
      </div>

      {/* Event Detail Modal */}
     {selectedEvent && (
        <Modal 
          show={showModal} 
          onHide={handleCloseModal}
          size="lg"
          centered
        >
          {/* ... (Modal Header) ... */}
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <img 
                  src={selectedEvent.image} 
                  alt={selectedEvent.title}
                  className="img-fluid rounded mb-3"
                />
              </div>
              <div className="col-md-6">
                <h5>Event Details</h5>
                {/* ... (List of event details: Date, Time, Location) ... */}
                <ul className="list-unstyled event-details-list">
                  <li>
                    <i className="far fa-calendar-alt"></i>
                    <strong>Date:</strong> {selectedEvent.date}
                  </li>
                  <li>
                    <i className="far fa-clock"></i>
                    <strong>Time:</strong> {selectedEvent.time}
                  </li>
                  <li>
                    <i className="fas fa-map-marker-alt"></i>
                    <strong>Location:</strong> {selectedEvent.location}
                  </li>
                </ul>
                <h5 className="mt-4">Description</h5>
                
                {/* 👇 FIX APPLIED HERE: Inline style ensures line breaks are respected */}
                <p style={{ whiteSpace: 'pre-line' }}> 
                  {selectedEvent.description}
                </p>
                
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            {/* <Button variant="primary" href={`/event/${selectedEvent.id}`}>
              Full Event Page
            </Button> */}
          </Modal.Footer>
        </Modal>
      )}
    </section>

























      <div className="facebook-page-container">
      <a
        href="https://web.facebook.com/profile.php?id=100077212276139&_rdc=1&_rdr#"
        target="_blank"
        rel="noopener noreferrer"
        className="box"
      >
        CEYLON EYE CARE OPTOMETRIC ASSOCIATION
      </a>
      <a
        href="https://web.facebook.com/profile.php?id=100065022691228&_rdc=1&_rdr#"
        target="_blank"
        rel="noopener noreferrer"
        className="box"
      >
        LIONS CLUB OF COLOMBO EYE CARE
      </a>
      <a
        href="https://web.facebook.com/share/g/pdWRq3HcEqJaRoEA/"
        target="_blank"
        rel="noopener noreferrer"
        className="box"
      >
        EYE CARE NETWORK
      </a>
      <a
        href="https://web.facebook.com/profile.php?id=61575697589733"
        target="_blank"
        rel="noopener noreferrer"
        className="box"
      >
        COMMUNITY EYE CARE SERVICES
      </a>
    </div>

      {/* Alumni Testimonials Section */}
      <div className="container mb-5">
        <h2 className="text-center">Alumni Testimonials</h2>
        <Carousel className="mt-4">
          <Carousel.Item>
            <div className="row justify-content-center">
              <div className="col-md-3 text-center mb-4">
                <img
                  src="alumni1.jpg" // Add image path here
                  alt="Optom. N. Arul Kumar"
                  className="rounded-circle mb-3"
                  width="100"
                  height="100"
                />
                <blockquote className="blockquote">
                  <p>
                    "The Eye Care Institute transformed my career. The education and hands-on experience were exceptional."
                  </p>
                  <footer className="blockquote-footer">
                  Optom. N. Arul Kumar 
                  </footer>
                </blockquote>
              </div>
              <div className="col-md-3 text-center mb-4">
                <img
                  src="alumni2.jpg" // Add image path here
                  alt="Dimuthu Prasanga "
                  className="rounded-circle mb-3"
                  width="100"
                  height="100"
                />
                <blockquote className="blockquote">
                <p>
                  "Thanks to the institute's unique programs and exceptional guidance, I have built a rewarding career and now work at a leading eye care clinic in Kenya."
                </p>
                  <footer className="blockquote-footer">
                      Optom. Dimuthu Prasanga <br /> Optica, kenya
                  </footer>
                </blockquote>
              </div>
              <div className="col-md-3 text-center mb-4">
                <img
                  src="alumni3.jpg" // Add image path here
                  alt="Optom. K Lahiru M Rodrigo"
                  className="rounded-circle mb-3"
                  width="100"
                  height="100"
                />
                <blockquote className="blockquote">
                <p>
                  "The practical skills and comprehensive training I gained during my time at the Eye Care Institute have been invaluable. They laid the foundation for my success, and I’m proud to now contribute to patient care at Nawaloka Hospital."
                </p>

                  <footer className="blockquote-footer">
                  Optom. K Lahiru M Rodrigo <br />  Nawaloka Hospital
                  </footer>
                </blockquote>
              </div>
              <div className="col-md-3 text-center mb-4">
                <img
                  src="alumni4.jpg" // Add image path here
                  alt=" Optom. Priyantha Mahanama - The chairman, Mahanama Optometrist, embilipitiya"
                  className="rounded-circle mb-3"
                  width="100"
                  height="100"
                />
                <blockquote className="blockquote">
                  <p>
                    "I never expected to gain such a deep understanding of optometry. The faculty was incredible!"
                  </p>
                  <footer className="blockquote-footer">
                  Optom. Priyantha Mahanama <br /> The chairman <br /> Mahanama Optometrist, embilipitiya
                  </footer>
                </blockquote>
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="row justify-content-center">
              <div className="col-md-3 text-center mb-4">
                <img
                  src="alumni5.jpg" // Add image path here
                  alt="Optom. B D T Himidira"
                  className="rounded-circle mb-3"
                  width="100"
                  height="100"
                />
                <blockquote className="blockquote">
                  <p>
                    "The institute's career development programs helped me secure a job at a prestigious clinic."
                  </p>
                  <footer className="blockquote-footer">
                  Optom. B D T Himidira
                  </footer>
                </blockquote>
              </div>
              <div className="col-md-3 text-center mb-4">
                <img
                  src="alumni6.jpg" // Add image path here
                  alt="optom. Udeni Gurusinghe"
                  className="rounded-circle mb-3"
                  width="100"
                  height="100"
                />
                <blockquote className="blockquote">
                  <p>
                    "I am grateful for the hands-on training and research opportunities at the Eye Care Institute."
                  </p>
                  <footer className="blockquote-footer">
                  Optom. Udeni Gurusinghe
                  </footer>
                </blockquote>
              </div>
              <div className="col-md-3 text-center mb-4">
                <img
                  src="alumni7.jpg" // Add image path here
                  alt=" B. Optom M. Lilendra Perera"
                  className="rounded-circle mb-3"
                  width="100"
                  height="100"
                />
                <blockquote className="blockquote">
                <p>
                  "The journey from the Eye Care Institute to SEGi University has been transformative. The exceptional guidance and academic environment prepared me for a successful career in optometry."
                </p>
                                <footer className="blockquote-footer">
                  Optom M. Lilendra Perera
                  </footer>
                </blockquote>
              </div>
              <div className="col-md-3 text-center mb-4">
                <img
                  src="alumni8.jpg" // Add image path here
                  alt="Optom. J A Deepal"
                  className="rounded-circle mb-3"
                  width="100"
                  height="100"
                />
                <blockquote className="blockquote">
                <p>
                  "Completing my Diploma in Optometry at the Eye Care Institute was a life-changing experience. The hands-on training and expert mentorship provided a strong foundation for my career, enabling me to excel as an optometrist at Panora Eye Hospital."
                </p>
                  <footer className="blockquote-footer">
                  Optom. J A Deepal <br />  CEO, Panora Eye Hospital
                  </footer>
                </blockquote>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
};

export default ECBody;